import React from 'react'
import './Experience.css'
import {HiCheck} from 'react-icons/hi'


const Experience = () => {
  return (
    <section id='experience'>

      <h5>Get to Know</h5>
      <h2>My Skills</h2>

      <div className="container experience__container">

        {/* FRONTEND */}

        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            
            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
                <h4>HTML</h4>
                <small className='text-light'>Experienced</small>
              </div>              
            </article>

            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
                <h4>JavaScript</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
                <h4>React</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
                <h4>Redux</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
              <h4>CSS</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
              <h4>Bootstrap</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>
        </div>

        {/* BACKEND */}

        <div className="experience__backend">
        <h3>Backend Development</h3>
          <div className="experience__content">
            
            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
              <h4>Node Js</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
              <h4>Git</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
              <h4>MySQL</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
              <h4>Sequalize</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <HiCheck className='experience__details-icon'/>
              <div>
              <h4>PostgreSQL</h4>
              <small className='text-light'>Experienced</small>
              </div>
            </article>

          </div>
        </div>

      </div>

    </section>
  )
}

export default Experience